import React, { memo } from 'react'
import { Link } from 'react-router-dom'

import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import {
  AddOutlined,
  DomainOutlined,
  GroupOutlined,
  KeyboardArrowDownOutlined,
  PublicOutlined,
} from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { Button, usePopoverState } from '@collaborate-health/uikit'
import { useCurrentCorporation } from '@tabeeb/modules/admin/corporations/hooks'

import { AnnouncementScope } from '../../enums'
import { getAvailableAnnouncementScopes } from '../../selectors'

const AnnouncementCreateButton: React.FC = () => {
  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  const scopes = useSelector(getAvailableAnnouncementScopes)
  const { corporation } = useCurrentCorporation()

  const options = []
  if (scopes.includes(AnnouncementScope.System)) {
    options.push({
      id: 'system',
      title: 'System announcement',
      icon: PublicOutlined,
      href: Routes.announcementCreateSystem,
    })
  }

  if (corporation && scopes.includes(AnnouncementScope.Corporation)) {
    options.push({
      id: 'corporation',
      title: 'Corporation announcement',
      icon: DomainOutlined,
      href: Routes.announcementCreateCorporation,
    })
  }

  if (scopes.includes(AnnouncementScope.Tenant)) {
    options.push({
      id: 'tenant',
      title: 'Tenant announcement',
      icon: GroupOutlined,
      href: Routes.announcementCreateTenant,
    })
  }

  if (options.length === 0) {
    return null
  }

  if (options.length === 1) {
    return (
      <Link to={options[0].href}>
        <Button startIcon={<AddOutlined />} color='primary' variant='contained' size='small'>
          Create new
        </Button>
      </Link>
    )
  }

  return (
    <>
      <Button
        ref={anchorRef}
        startIcon={<AddOutlined />}
        endIcon={<KeyboardArrowDownOutlined />}
        color='primary'
        variant='contained'
        size='small'
        onClick={onOpen}
      >
        Create new
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {options.map(({ id, href, icon: Icon, title }) => (
          <Link key={id} to={href}>
            <MenuItem>
              <ListItemIcon>
                <Icon fontSize='small' />
              </ListItemIcon>
              <ListItemText primary={title} />
            </MenuItem>
          </Link>
        ))}
      </Menu>
    </>
  )
}

export default memo(AnnouncementCreateButton)

